import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { DemograficosService } from 'app/main/wizard-cgo/services/demograficos.service';
import { DemographicService } from "../services/demographics.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';

import { BroadcastTranslate } from './broadcasttranslate.service';
import { BroadcastPreview } from './broadcastpreview.service';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};

import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import { DragComponent } from './drag/drag.component';


@Component({
    selector     : 'demo-tabs-main',
    templateUrl  : './demotabs.component.html',
    styleUrls    : ['./demotabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class DemoTabsComponent implements OnInit {

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  //boolean paso completo
  pasoCompleto = false;

  numArrayTraduc: number = 0;

  constructor(
    private demograficosService: DemograficosService,
    public dialog: MatDialog,
    private wizardService: WizardService,
    private translateSrv: TranslateService,
    private broadcastTranslate: BroadcastTranslate,
    private demographicService: DemographicService,
    private broadcastPreview: BroadcastPreview,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService) {

    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    // console.log('CONSTRUCTOR');

  }

  ngOnInit() {
    // $(document).ready(function(){
    //   $(".finishBt").width($(".finishBt").parent().width());
    // });
    // $(window).resize(function(){
    //   $(".finishBt").width($(".finishBt").parent().width());
    // });

    this.obtieneCertificarActual();

  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.demograficosService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.demograficosService.getStatusDemograficos(this.productoCertificar.idCertificar).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
          this.pasoCompleto = true;
      });

      this.getStatusModal();
      this.getNumTraducciones();
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      demograficos: 1
    };
    console.log(datos);
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
            this.modalInformativo('DEMOGRAFICOS');
      }
    });
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      demograficos: 2
    };
    // console.log(datos);
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  getNumTraducciones(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    };
    this.demographicService.obtenerDemograficos(data).subscribe(response => {
      if(response['message'] == 'Success'){
        this.numArrayTraduc = response['arrayMostrar'].length;
      }
    }, error => {
      console.log("error", error);
    })
  }

  completarPaso(){
    if(this.pasoCompleto){
      this.aletaRestric('DEMOGRAFICOS.COMPLETADO',null,'warning');
    }
    else{
      this.obtenerDemograficos();
    }


  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }
  // aletaRestric(mensaje:string,confirmar?:boolean){
  //
  //     let infoModal: adverModal = {'tipo': 3, 'confirma': confirmar, 'mensaje': mensaje, 'diccionario': 'WIZARD.CERTIFICAR.'};
  //     const confirmaMod = this.dialog.open(ModalComponent, { data:infoModal });
  //
  //     if(confirmar){
  //       confirmaMod.afterClosed().subscribe(resultado => {
  //         if(resultado){
  //           this.demograficosService.guardaStatusDemograficos(this.productoCertificar.fechaCertificar).subscribe( (data: backInter.RespuestaGen) => {
  //             if(data.message == '213'){
  //               this.aletaRestric('DEMOGRAFICOS.'+data.message);
  //               this.pasoCompleto = true;
  //               this.enviaOrdenWizard();
  //             };
  //           });
  //         }
  //       });
  //     }
  //
  // }
  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.demograficosService.guardaStatusDemograficos(this.productoCertificar.idCertificar).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '213'){
              this.aletaRestric('DEMOGRAFICOS.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }

  }

  sendBroadcast(indexTab){
    indexTab = indexTab['index'];
    console.log(indexTab);
    if(indexTab == 1){
      // send product data to subscribers via observable subject
      this.broadcastTranslate.sendEvent();
    }else if(indexTab == 2){
      // send product data to subscribers via observable subject
      this.broadcastPreview.sendEvent();
    }
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }


  arraytraducciones: backInter.traduccionesDemo[];
  arrayReactivo: backInter.demoabiertasTraduccion[];
  arrayValidacion=0;
  arrayReactivo_second: backInter.demoabiertasTraduccion[];
  arrayValidacionSecond=0;
  validacionIdioma=0;
  private obtenerDemograficos(){
    let texto = 'MODALES.VALIDACION.ERROR1';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    };
      this.demograficosService.obtenerDemograficos(data)
      .subscribe( (response:backInter.respuestaDemoTraducciones) => {
        console.log("Translate demo");
        if(response.message == 'Success'){
          this.arraytraducciones = response.arrayMostrar;
          console.log(this.arraytraducciones);
          if(this.arraytraducciones.length>0){
            for(let i = 0; i<this.arraytraducciones.length; i++){
              this.arrayReactivo=this.arraytraducciones[i].demograficos;
              for(let j=0; j < this.arrayReactivo.length; j++){
                if(this.arrayReactivo[j].preguntaTraduccion.length > 0){
                  this.arrayValidacion++;
                }
              }// Fin segundo for
              if(this.arrayReactivo.length == this.arrayValidacion){
                console.log("Correcto pos "+i);
                this.arrayValidacion=0;
                this.validacionIdioma++;
              }else{
                this.arrayValidacion=0;
              }
            }// Fin primer for
            if(this.validacionIdioma == this.arraytraducciones.length){
              this.validacionIdioma=0;
              this.aletaRestric('REACTIVOS.COMPLETAR',true);
            }else{
              this.validacionIdioma=0;
              Swal.fire(
                ''+texto,
                '',
                'warning'
              );
            }

          }else{ // SEGUNDA PARTE
            if(this.pasoCompleto){
              this.aletaRestric('DEMOGRAFICOS.COMPLETADO');
            }
            else{
              this.aletaRestric('DEMOGRAFICOS.COMPLETAR',true);
              //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
            }
          }
          //demograficos



          /*if(this.arraytraducciones.length>0){
            this.arrayReactivo=this.arraytraducciones[0].demograficos;
            for(let i=0; i < this.arrayReactivo.length;i++){
              if(this.arrayReactivo[i].preguntaTraduccion.length > 0){
                this.arrayValidacion++;
              }
            }
            console.log("Tamanio reactivo "+this.arrayReactivo.length);
            console.log("Bandera "+this.arrayValidacion);
            if(this.arrayReactivo.length == this.arrayValidacion){
             this.arrayValidacion=0;
             this.arrayValidacionSecond=0;
             console.log("Todo correcto");
               //*************************************************************
               if(this.arraytraducciones.length > 1){
                this.arrayReactivo_second=this.arraytraducciones[1].demograficos;
                for(let i=0; i < this.arrayReactivo_second.length;i++){
                  if(this.arrayReactivo_second[i].preguntaTraduccion.length > 0){
                    this.arrayValidacionSecond++;
                  }
                }
                console.log("Bandera 2 "+this.arrayValidacionSecond);
                if(this.arrayReactivo_second.length == this.arrayValidacionSecond){
                  if(this.pasoCompleto){
                    this.aletaRestric('REACTIVOS.COMPLETADO',null,'warning');
                  }
                  else{
                    this.aletaRestric('REACTIVOS.COMPLETAR',true);
                  }
                }else{ // No están completas
                  this.arrayValidacion=0;
                  this.arrayValidacionSecond=0;
                  Swal.fire(
                    ''+texto,
                    '',
                    'warning'
                  );
                }
              }else{ //**************************************************************
                if(this.pasoCompleto){
                  this.aletaRestric('DEMOGRAFICOS.COMPLETADO');
                }else{
                  this.aletaRestric('DEMOGRAFICOS.COMPLETAR',true);
                  //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
                }

              }
             }else{
             this.arrayValidacion=0;
             this.arrayValidacionSecond=0;
             console.log("TODO INCORRECTO");
             Swal.fire(
               ''+texto,
               '',
               'warning'
             );
            }
          }else{ // SEGUNDA PARTE
            if(this.pasoCompleto){
              this.aletaRestric('DEMOGRAFICOS.COMPLETADO');
            }
            else{
              this.aletaRestric('DEMOGRAFICOS.COMPLETAR',true);
              //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
            }

          } */
        }
      }, error => {
        console.log("error", error);
      })
  }

}
